// import Cookies from 'js-cookie'
import { encryptor, GetItem } from '../utils/encryptor'
const TokenKey = 'Admin-Token'
const userTypeKey = 'User-Type'
const locationKey = 'Location'
const stockPointKey = 'StockPoint'
const loginTypeKey = 'LoginType'
export function getToken() {
  return GetItem(TokenKey)
  // return Cookies.get(TokenKey)
}
export function setToken(token) {
  var TokenKey1 = btoa(TokenKey)
  return encryptor(token, TokenKey1, 19)
  // return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return localStorage.removeItem(btoa(TokenKey))
  // return Cookies.remove(TokenKey)
}
export function setUserType(uType) {
  var uTypeKey = btoa(userTypeKey)
  return localStorage.setItem(uTypeKey, 2)
}
export function getUserType() {
  var uTypeKey = btoa(userTypeKey)
  return localStorage.getItem(uTypeKey)
}
export function removetUserType() {
  return localStorage.removeItem(btoa(userTypeKey))
}
export function setLocation(uType) {
  var uTypeKey = btoa(locationKey)
  return localStorage.setItem(uTypeKey, uType)
}
export function getLocation() {
  var uTypeKey = btoa(locationKey)
  return localStorage.getItem(uTypeKey)
}
export function removeLocation() {
  return localStorage.removeItem(btoa(locationKey))
}
export function setStockPoint(uType) {
  var uTypeKey = btoa(stockPointKey)
  return localStorage.setItem(uTypeKey, uType)
}
export function getStockPoint() {
  var uTypeKey = btoa(stockPointKey)
  return localStorage.getItem(uTypeKey)
}
export function removeStockPoint() {
  return localStorage.removeItem(btoa(stockPointKey))
}
export function setLoginType(uType) {
  var uTypeKey = btoa(loginTypeKey)
  return localStorage.setItem(uTypeKey, uType)
}
export function removeLoginType() {
  return localStorage.removeItem(btoa(loginTypeKey))
}
export function getLoginType() {
  var uTypeKey = btoa(loginTypeKey)
  return localStorage.getItem(uTypeKey)
}
